/**
 * Deploy base comes from Vite `base` (import.meta.env.BASE_URL).
 * Route paths must NOT include this prefix — BrowserRouter basename handles it.
 */

/** Vite base always has a trailing slash, e.g. `/tln/` or `/`. */
export function getAppBasePath(): string {
  const raw =
    (typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL) || '/';
  return raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

/**
 * React Router basename (no trailing slash).
 * Undefined at domain root (recommended for BrowserRouter when base is `/`).
 */
export const APP_BASENAME: string | undefined = getAppBasePath() || undefined;
